import { Component, OnDestroy, OnInit, computed, inject, signal } from '@angular/core';
import { AppstateService } from './core/appstate/appstate.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy{
  appStateService = inject(AppstateService);
  collapsed = this.appStateService.collapsed;
  version = this.appStateService.version;
  profilePicSize = computed(() => (this.collapsed() ? '32' : '100'));
  calculateWidth = computed(() => (this.collapsed() ? '65px' : '250px'));
  isProd = environment.production;
  apiResponse = signal<string>("");
  
  ngOnInit(): void {
    this.appStateService.init();
  }

  ngOnDestroy(): void {
    this.appStateService.Destroy();
  }

  login() {
    this.appStateService.login();
  }

  logout() {
    this.appStateService.logout();
  }
}
